import { useMemo } from "react";
import { ValuesPerSide } from "../useHydratedCubeData/types";
import { getAverageOfSides } from "./utils";
import { CubeSideName } from "../../components/Сube/types";
import { OverviewData } from "./types";

export function useCubeOverviewData(
  valuesPerSide: Record<CubeSideName, ValuesPerSide> | undefined
) {
  return useMemo<OverviewData>(
    () => getAverageOfSides(valuesPerSide),
    [valuesPerSide]
  );
}
